function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M18.764 15.82c.832-.574 1.415-1.517 1.415-2.391 0-1.938-1.5-3.429-3.429-3.429h-5.357v12h6.034c1.792 0 3.18-1.457 3.18-3.249 0-1.302-.737-2.417-1.843-2.931zm-4.8-3.677h2.572c.711 0 1.285.574 1.285 1.286 0 .711-.574 1.285-1.285 1.285h-2.572v-2.571zm3 7.714h-3v-2.571h3c.712 0 1.286.574 1.286 1.285 0 .712-.574 1.286-1.286 1.286z",
  fill: "#4A4A4A",
  fillRule: "nonzero"
})));